import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { CustomButton } from '../../../../components/UI/CustomButton';

interface StartCourseBtnProps {
  isCourseStarted: boolean;
  handleStartCourse: () => void;
  className?: string;
}

const StartCourseBtn: FC<StartCourseBtnProps> = ({
  isCourseStarted,
  handleStartCourse,
  className = '',
}) => {
  const { t } = useTranslation();
  const params = useParams();

  if (isCourseStarted) {
    return (
      <Link to={`/courses/${params?.slug}/progress`}>
        <CustomButton btnClass={className}>{t('page.course.continueCourse')}</CustomButton>
      </Link>
    );
  }

  return (
    <CustomButton onClick={handleStartCourse} btnClass={className}>
      {t('page.course.startCourse')}
    </CustomButton>
  );
};

export default StartCourseBtn;
